import countries from 'i18n-iso-countries';
import {
  getCountryCallingCode,
  isSupportedCountry,
  parsePhoneNumberFromString,
} from 'libphonenumber-js';
import validatePhone from 'phone';

import {isNotNil} from 'ramda';

import {PhoneNumber} from '@dms/api/shared';

import {Nullish} from 'shared/web';

const isValidMobileNumber = (phone: PhoneNumber | Nullish) =>
  validatePhone(phone?.number ?? '', {
    country: phone?.countryCode,
    validateMobilePrefix: false,
  }).isValid;

const isValidNumberInSelectedCountry = (phone: PhoneNumber | Nullish) => {
  const country = countries.alpha3ToAlpha2(phone?.countryCode ?? '');

  if (isNotNil(country) && isSupportedCountry(country)) {
    const parsed = parsePhoneNumberFromString(phone?.number ?? '', country);

    return (
      parsed?.isValid() === true && parsed.countryCallingCode === getCountryCallingCode(country)
    );
  }

  return false;
};

export const isPhoneNumberValid = (phone: PhoneNumber | Nullish) =>
  isValidMobileNumber(phone) || isValidNumberInSelectedCountry(phone);
